export default "__VITE_ASSET__Fwi6QyJ___"